var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "focus-trap",
    {
      model: {
        value: _vm.consumModeTrap,
        callback: function callback($$v) {
          _vm.consumModeTrap = $$v
        },
        expression: "consumModeTrap"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "cw-structural-element",
          class: {
            "cw-structural-element-consumemode": _vm.consumeMode
          }
        },
        [
          _vm.structuralElement
            ? _c(
                "div",
                {
                  staticClass: "cw-structural-element-content"
                },
                [
                  _c("courseware-ribbon", {
                    attrs: {
                      canEdit: false,
                      disableSettings: true,
                      disableAdder: true
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "buttons",
                          fn: function fn() {
                            return [
                              _vm.prevElement
                                ? _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to:
                                          "/structural_element/" +
                                          _vm.prevElement.id
                                      }
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "cw-ribbon-button cw-ribbon-button-prev",
                                        attrs: {
                                          title: _vm.textRibbon.perv
                                        }
                                      })
                                    ]
                                  )
                                : _c("div", {
                                    staticClass:
                                      "cw-ribbon-button cw-ribbon-button-prev-disabled",
                                    attrs: {
                                      title: _vm.$gettext(
                                        "keine vorherige Seite"
                                      )
                                    }
                                  }),
                              _vm._v(" "),
                              _vm.nextElement
                                ? _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to:
                                          "/structural_element/" +
                                          _vm.nextElement.id
                                      }
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "cw-ribbon-button cw-ribbon-button-next",
                                        attrs: {
                                          title: _vm.textRibbon.next
                                        }
                                      })
                                    ]
                                  )
                                : _c("div", {
                                    staticClass:
                                      "cw-ribbon-button cw-ribbon-button-next-disabled",
                                    attrs: {
                                      title: _vm.$gettext("keine nächste Seite")
                                    }
                                  })
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "breadcrumbList",
                          fn: function fn() {
                            return [
                              _vm._l(_vm.ancestors, function(ancestor) {
                                return _c(
                                  "li",
                                  {
                                    key: ancestor.id,
                                    staticClass: "cw-ribbon-breadcrumb-item",
                                    attrs: {
                                      title: ancestor.attributes.title
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to:
                                                "/structural_element/" +
                                                ancestor.id
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                ancestor.attributes.title || "–"
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  staticClass:
                                    "cw-ribbon-breadcrumb-item cw-ribbon-breadcrumb-item-current",
                                  attrs: {
                                    title:
                                      _vm.structuralElement.attributes.title
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.structuralElement.attributes
                                          .title || "–"
                                      )
                                    )
                                  ])
                                ]
                              )
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "breadcrumbFallback",
                          fn: function fn() {
                            return [
                              _c(
                                "li",
                                {
                                  staticClass:
                                    "cw-ribbon-breadcrumb-item cw-ribbon-breadcrumb-item-current",
                                  attrs: {
                                    title:
                                      _vm.structuralElement.attributes.title
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.structuralElement.attributes.title
                                      )
                                    )
                                  ])
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      515457015
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "cw-container-wrapper",
                      class: {
                        "cw-container-wrapper-consume": _vm.consumeMode
                      }
                    },
                    [
                      _vm.structuralElementLoaded
                        ? _c(
                            "div",
                            {
                              staticClass: "cw-companion-box-wrapper"
                            },
                            [
                              _vm.noContainers
                                ? _c("courseware-empty-element-box", {
                                    attrs: {
                                      noContainers: _vm.noContainers
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.containers, function(container) {
                        return _c(_vm.containerComponent(container), {
                          key: container.id,
                          tag: "component",
                          staticClass: "cw-container-item",
                          attrs: {
                            container: container,
                            canEdit: false,
                            canAddElements: false,
                            isTeacher: false
                          }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }